'use client'

import { useTranslations } from 'next-intl'
import { CalendarOff } from 'lucide-react'

/**
 * Replaces the booking sidebar on a property whose
 * `properties.is_booking_enabled` switch is off. The property page stays
 * reachable (it is marketing content); only the selling surface goes away.
 */
export function OnlineBookingDisabledNotice() {
  const t = useTranslations('booking.property')
  return (
    <div className="lg:sticky lg:top-24 rounded-xl border bg-card p-6 text-center shadow-sm">
      <CalendarOff className="mx-auto mb-3 h-8 w-8 text-muted-foreground" aria-hidden="true" />
      <p className="font-semibold">{t('onlineBookingDisabledTitle')}</p>
      <p className="mt-2 text-sm text-muted-foreground">{t('onlineBookingDisabledBody')}</p>
    </div>
  )
}
